// Lista versionamiento
export const LISTA_VERSIONAMIENTO_SUCCESS = 'LISTA_VERSIONAMIENTO_SUCCESS';
export const LISTA_VERSIONAMIENTO_FAIL = 'LISTA_VERSIONAMIENTO_FAIL';
export const LISTA_VERSIONAMIENTO_REQUEST = 'LISTA_VERSIONAMIENTO_REQUEST';